import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-labelledby", "id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "icon"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { "aria-label": "message" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  role: "banner",
  class: "visually-hidden text-wrap"
}

import DOMPurify from 'dompurify'
import {INotification} from "@/interfaces/components/general/INotification";
// @ts-ignore
import {Notification} from 'bootstrap-italia'
import {ref, Ref, watch} from "vue";
import {NotificationStatus} from "@/enums/components/general/NotificationStatus";
import {useNotificationStore} from "@/stores/notification";


export default /*@__PURE__*/_defineComponent({
  __name: 'Notification',
  setup(__props) {


const notificationStore = useNotificationStore();
const notifications = ref<Map<string, boolean>>(new Map<string, boolean>())
const notificationsElement = ref<Map<string, Notification>>(new Map<string, Notification>())
const notificationsComputed = notificationStore.notificationsData as Ref<Map<string, INotification>>

function notificationIcon(notify: INotification) {
  if (notify.icon) {
    return notify.icon
  }
  switch (notify.status) {
    case NotificationStatus.INFO:
      return 'it-info-circle';
    case NotificationStatus.SUCCESS:
      return 'it-check-circle'
    case NotificationStatus.ERROR:
      return 'it-close-circle'
    case NotificationStatus.WARNING:
      return 'it-error'
    default:
      return undefined
  }
}

function notificationClass(notify: INotification) {
  const cssClass = ['notification', 'topLayerNotification'];
  if (notify.icon || notify.status) {
    cssClass.push('with-icon');
  }
  if (notify.status) {
    cssClass.push(notify.status)
  }
  if (notify.position) {
    cssClass.push(notify.position)
  }
  if (notify.status === NotificationStatus.ERROR || notify.status === NotificationStatus.WARNING) {
    notify.dismissable = true
    notify.timeout = 10000
    cssClass.push('dismissable')
  }
  return cssClass.join(' ');
}

watch(notificationsComputed, (value: Map<string, INotification>) => {
  const newKeys = Array.from(value.keys());
  newKeys.forEach((key: string) => {
    if (!notifications.value.has(key)) {
      notifications.value.set(key, false);
    }
  })
}, {deep: true})

watch(notifications, (value: Map<string, boolean>) => {
  value.forEach((completed: boolean, key: string) => {
    runProcess(completed, key)
  })
}, {deep: true})

//TODO: Trovare una soluzione alternativa al timeout
setInterval(function () {
  notifications.value.forEach((completed: boolean, key: string) => {
    runProcess(completed, key)
  })
}, 1000);

function runProcess(completed: boolean, key: string) {
  if (!completed) {
    const element = document.getElementById(key);
    if (element) {
      notifications.value.set(key, true);
      if (!notificationsElement.value.has(key)) {
        const notifica: INotification | undefined = notificationsComputed.value.get(key);
        if (notifica !== undefined) {
          const timeout: number = notifica.timeout ?? 6000;
          const notificationElement = new Notification(element, {timeout: timeout});
          notificationsElement.value.set(key, notificationElement)
          notificationElement.show();
          // È stato gestito in questo modo perché purtroppo non funzionano gli event listener di bootstrap italia
          setTimeout(() => {
            hide(key);
          }, timeout + 300)
        }
      }
    }
  }
}

function hide(id: string) {
  const notificationElement: Notification | undefined = notificationsElement.value.get(id);
  const notifica: INotification | undefined = notificationsComputed.value.get(id);
  if (notificationElement !== undefined) {
    notificationElement.hide();
    notifications.value.delete(id);
    notificationStore.removeNotification(id);
    const element = document.getElementById(id);
    if (element) {
      element.innerHTML = '';
    }
    notifica?.afterDismissCallback?.()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationsComputed), ([id, notify]) => {
    return (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(notificationClass(notify)),
      role: "alert",
      "aria-labelledby": id + '-title',
      id: id
    }, [
      _createElementVNode("section", {
        "aria-label": "title",
        id: id + '-title',
        class: "h5"
      }, [
        (notify.status || notify.icon)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [
              _createElementVNode("use", {
                href: '/dist/svg/sprites.svg#' + notificationIcon(notify)
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(notify.title), 1)
      ], 8, _hoisted_2),
      _createElementVNode("section", _hoisted_5, [
        (notify.message)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "text-black text-wrap",
              innerHTML: _unref(DOMPurify).sanitize(notify.message ?? '')
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      (notify.dismissable || notify.status === _unref(NotificationStatus).ERROR || notify.status === _unref(NotificationStatus).WARNING)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn notification-close",
            onClick: ($event: any) => (hide(id)),
            "data-bs-toggle": "tooltip",
            title: "Chiudi notifica"
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("svg", { class: "icon" }, [
              _createElementVNode("use", { href: "/dist/svg/sprites.svg#it-close" })
            ], -1)),
            _createElementVNode("span", _hoisted_8, "Chiudi notifica: " + _toDisplayString(notify.title), 1)
          ], 8, _hoisted_7))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1))
  }), 256))
}
}

})